module.exports = __webpack_public_path__ + "static/media/retomar-svg.057ae556.svg";